export interface SettingsLog {
  settingsLogId: number;
  timestamp: Date;
  message?: string | null;
  action: SettingsAction;
  serializedData?: string | null; 
  entityName: string;
  entityId?: string | null;
  userId: number;
  userEmail: string;
}

export enum SettingsAction {
  Created = "Created",
  Updated = "Updated",
  Deleted = "Deleted",
}